<template>
  <div>
    <v-toolbar class="toolbar" app height="70">
      <v-toolbar-title class="navigation__title">
        <a href="/" class="header__logo" title="Careship">
          <CSSVGIcon
            iconName="careship-logo"
            classes="logo__careship hidden-sm-and-down"
          />
          <CSSVGIcon
            iconName="careship-mark"
            classes="logo__careship hidden-md-and-up"
          />
        </a>
      </v-toolbar-title>

      <v-spacer class="hidden-xs-only"></v-spacer>

      <div class="navigation-step hidden-xs-only">
        <div
          class="navigation-step__item"
          v-for="(item, index) in steps"
          :key="index"
        >
          <a
            @click.stop.prevent="goToStep(item.route)"
            :class="[
              'navigation-step__link',
              { active: isActive(item.num) },
              {
                disabled:
                  item.num == getNumOfStep() ||
                  isStepDisabled(item.num) ||
                  disableHeader,
              },
            ]"
          >
            {{ item.num }}. {{ getTitle(item.text, isActive(item.num)) }}
          </a>
          <CSSVGIcon
            v-if="index != numberOfSteps - 1"
            classes="icon navigation-step--arrow"
            iconName="chevron-right"
            guessSize
          />
        </div>
      </div>

      <div class="navigation-mobile hidden-sm-and-up">
        <v-menu
          class="navigation-mobile__menu"
          close-delay="50"
          open-on-click
          close-on-content-click
          attach
          full-width
        >
          <v-btn
            flat
            slot="activator"
            id="header_step_mobile"
            class="navigation-mobile__button"
          >
            {{ getNumOfStep() }}. {{ getCurrentTitle() }}
          </v-btn>

          <v-list :dense="false">
            <v-list-tile
              v-for="(item, index) in steps"
              :key="index"
              :to="'/buchung/' + item.route"
              class="navigation-mobile__link"
              active-class="active"
              :inactive="item.num > getNumOfStep()"
            >
              <v-list-tile-action> </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title
                  >{{ item.num }}. {{ item.text }}</v-list-tile-title
                >
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile
              href="tel:(030)220128331"
              class="navigation-mobile__phone headerPhone"
              avatar
            >
              <v-list-tile-action> </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  <CSSVGIcon classes="icon__phone" iconName="phone-call" />
                  <span class="headerPhone__number">{{
                    translate('SPAN_FOOTER_TELEPHONE')
                  }}</span>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>

      <v-spacer></v-spacer>
      <v-toolbar-items class="toolbar-phone hidden-xs-only">
        <a href="tel:(030)220128331" class="headerPhone">
          <CSSVGIcon classes="icon__phone" iconName="phone-call" guessSize />
          <span class="headerPhone__number hidden-md-and-down">{{
            translate('SPAN_FOOTER_TELEPHONE')
          }}</span>
        </a>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CSSVGIcon from '@/components/atoms/icons/CSSVGIcon.vue'
import { eventBus } from '@/main'

export default {
  name: 'CSToolbar',
  components: {
    CSSVGIcon,
  },
  data() {
    return {
      disableHeader: false,
    }
  },
  computed: {
    ...mapGetters({
      hasSelectedServices: 'services/hasSelectedServices',
    }),

    step() {
      return this.$route.meta.bookingFunnelSubPage
    },
    steps() {
      return [
        {
          num: 1,
          text: this.translate('HEADER_BOOKINGFUNNEL_STEP1'),
          route: 'services',
        },
        {
          num: 2,
          text: this.translate('HEADER_BOOKINGFUNNEL_STEP2'),
          route: 'profilerstellung',
        },
        {
          num: 3,
          text: this.translate('HEADER_BOOKINGFUNNEL_STEP3'),
          route: 'terminplanung',
        },
        {
          num: 4,
          text: this.translate('TITLE_SUMMARYCARD_PAYMENTSDETAIS_VERSION_B'),
          route: 'bezahlung',
        },
      ]
    },
    numberOfSteps() {
      return this.steps.length
    },
    isCarereceiverProfileFilled() {
      return this.$store.getters[
        'carereceiver/getIfCarereceiverProfileFilled'
      ]()
    },
    isSheduleFilled() {
      return this.$store.getters['scheduling/getIsScheduleFilled']()
    },
  },
  beforeUpdate() {
    if (this.step) {
      if (!this.routeExists()) {
        this.$router.push('/buchung/services')
      }
    }
  },
  methods: {
    goToStep(route) {
      const currentNum = this.getNumOfStep()

      const selected = this.steps.find(item => item.route === route)

      const fullRoute = `/buchung/${route}`
      if (selected.num > currentNum) {
        eventBus.$emit('goToNextStep', {
          route: fullRoute,
          save: true,
        })
      } else {
        eventBus.$emit('goToNextStep', {
          route: fullRoute,
          save: false,
        })
      }

      this.$gtm.trackEvent({
        category: 'navigation',
        action: 'user clicked on one of the booking funnel header steps',
        label: `the element the user interacted with: ${selected.text}`,
      })
    },
    isStepDisabled(num) {
      switch (num) {
        case 2:
          return !this.hasSelectedServices
        case 3:
          return !this.hasSelectedServices || !this.isCarereceiverProfileFilled
        case 4:
          return (
            !this.hasSelectedServices ||
            !this.isCarereceiverProfileFilled ||
            !this.isSheduleFilled
          )
        default:
          return false
      }
    },
    routeExists() {
      return this.steps.some(stepItem => stepItem.route === this.step)
    },
    getNumOfStep() {
      const step = this.steps.find(item => item.route === this.step)

      return step ? step.num : 1
    },
    getCurrentTitle() {
      const step = this.steps.find(item => item.route === this.step)

      return step.text
    },
    isActive(number) {
      return number === this.getNumOfStep()
    },
    getTitle(title, active) {
      if (!active && this.$vuetify.breakpoint.mdAndDown) {
        // shorten the title and add question mark
        return `${title.replace(/ .*/, '')}?`
      }

      return title
    },
    translate(key) {
      return this.$store.getters.translation(key)
    },
  },
  created() {
    eventBus.$on('submitting', () => {
      this.disableHeader = true
    })
    eventBus.$on('submitted', () => {
      this.disableHeader = false
    })
  },
}
</script>
